import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Status, useSession } from '@lendi/lala-react';

import { authSuccess } from '@funnels/redux-store';
import { apiUtil } from '@funnels/utils';

export function useAuth() {
  const session = useSession();
  const dispatch = useDispatch();
  useMemo(() => {
    if (session.status === Status.Authenticated) {
      const token = session.token || '';
      apiUtil.setToken(token);
      dispatch(authSuccess(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.status, session.token]);
}
